'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _draftJs = require('draft-js');

var _katex = require('katex');

var _katex2 = _interopRequireDefault(_katex);

var _TexInlineBlockModal = require('./TexInlineBlockModal');

var _TexInlineBlockModal2 = _interopRequireDefault(_TexInlineBlockModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TexComponent = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(TexComponent, _Component);

  function TexComponent(props) {
    (0, _classCallCheck3.default)(this, TexComponent);

    var _this = (0, _possibleConstructorReturn3.default)(this, (TexComponent.__proto__ || (0, _getPrototypeOf2.default)(TexComponent)).call(this, props));

    var contentState = props.contentState,
        entityKey = props.entityKey;

    var entity = contentState.getEntity(entityKey);

    var _entity$getData = entity.getData(),
        content = _entity$getData.content;

    _this.state = {
      editing: false,
      contentState: contentState,
      entityKey: entityKey,
      content: content
    };
    return _this;
  }

  (0, _createClass3.default)(TexComponent, [{
    key: 'handleEditClick',
    value: function handleEditClick() {
      this.props.onStartEdit();
      this.setState({
        editing: true
      });
    }
  }, {
    key: 'handleSave',
    value: function handleSave(newContent) {
      this.props.onEndEdit();
      this.setState({
        editing: false,
        content: newContent
      });
      _draftJs.Entity.mergeData(this.props.entityKey, { content: newContent });
    }
  }, {
    key: 'handleCancel',
    value: function handleCancel() {
      this.props.onEndEdit();
      this.setState({
        editing: false
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var styles = require('./TeXInlineBlock.scss');
      var _state = this.state,
          editing = _state.editing,
          content = _state.content;
      var offsetKey = this.props.offsetKey;


      var texHtml = void 0;
      try {
        texHtml = _katex2.default.renderToString(content, { displayMode: true, throwOnError: true });
      } catch (error) {
        texHtml = error.message;
      }

      var modalProps = {
        onSave: this.handleSave.bind(this),
        onCancel: this.handleCancel.bind(this),
        content: content
      };

      return _react2.default.createElement(
        'span',
        { 'data-offset-key': offsetKey,
          onMouseDown: this.handleEditClick.bind(this)
        },
        editing ? _react2.default.createElement(_TexInlineBlockModal2.default, modalProps) : null,
        _react2.default.createElement('span', {
          className: styles.texInlineBlock,
          dangerouslySetInnerHTML: { __html: texHtml },
          contentEditable: 'false'
        })
      );
    }
  }]);
  return TexComponent;
}(_react.Component), _class.propTypes = {
  contentState: _react.PropTypes.object,
  entityKey: _react.PropTypes.String,
  onStartEdit: _react.PropTypes.func,
  onEndEdit: _react.PropTypes.func,
  offsetKey: _react.PropTypes.String
}, _temp);
exports.default = TexComponent;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/RichEditor/components/TexComponent.js
// module id = 1187
// module chunks = 0